import axios from 'axios.js'

export const GET_USER_LIST = 'GET_USER_LIST'
export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const SERCH_USER = 'SERCH_USER'
export const SET_USER_ACTIVE = 'SET_USER_ACTIVE'
export const SET_USER_ACTIVE_LIST = 'SET_USER_ACTIVE_LIST'
export const SERCH_ALL_USER = 'SERCH_USER'

export const getCurrentUser = () => (dispatch) => {
    console.log("Get All User called")
    axios.get('/api/user').then((res) => {
        dispatch({
            type: GET_CURRENT_USER,
            payload: res.data,
        })
    })
}

export const getAllUsers = (search, paginage) => (dispatch) => {
    console.log("Get All User called")
    
    axios.get('/api/users',{...paginage, search:search}).then((res) => {
        if(res.data.status === 0){
            dispatch({
                type: GET_USER_LIST,
                payload: res.data.data,
            })
        }
    })
}

export const findUser = (search) => (dispatch) => {
    let param = {'search': search}
    axios.get('/users',{ params:param}).then((res) => {
        dispatch({
            type: SERCH_USER,
            payload: res.data.data,
        })
    })
}

export const setUserActive = (uid,active) => (dispatch) => {
    axios.post('/api/user/active',{user:uid, status: active}).then((res) => {
        dispatch({
            type: SET_USER_ACTIVE,
            payload: res.data,
        })
    })
}
export const setUserActiveList = (uids, active) => (dispatch) => {
    axios.get('/api/user/active-list',{user:uids, status: active}).then((res) => {
        dispatch({
            type: SET_USER_ACTIVE_LIST,
            payload: res.data,
        })
    })
}

